import styled from 'styled-components';
import { BaseCheckbox } from '@app/components/common/BaseCheckbox/BaseCheckbox';

export const FilterCheckboxGroup = styled(BaseCheckbox.Group)`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
